module.exports = "/_next/static/images/suv-32cf6ccc64bf2146d3f74dde6e8e81cd.jpg";